import { render, staticRenderFns } from "./MatchingCandidates.vue?vue&type=template&id=288f29a0&scoped=true&"
import script from "./MatchingCandidates.vue?vue&type=script&lang=ts&"
export * from "./MatchingCandidates.vue?vue&type=script&lang=ts&"
import style0 from "./MatchingCandidates.vue?vue&type=style&index=0&id=288f29a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f29a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VSelect,VSkeletonLoader})
